import styled from "styled-components";

interface ItemProps {
  flex?: number;
}

interface paramsProps {
  results?: any[];
  onClick(selected: { title: string, content: string }[]): void;
}

export function Results({ results, onClick }: paramsProps) {
  if(!results) results = [];
  
  function mapRowModalData(item: any) {
    return [{
      title: "Data",
      content: item.date || '-'
    }, {
      title: "Título",
      content: item.title
    }, {
      title: "Autor",
      content: item.author || '-'
    }, {
      title: "url",
      content: item.pdf_url
    }]
  }

  return (
    <Content>
      <Title>Mais recentes</Title>
      <Table>
        {results.length > 0 ? (
          <>
            <Head>
              <HeadItem flex={3}>Data</HeadItem>
              <HeadItem flex={9}>Título</HeadItem>
              <HeadItem flex={6}>Autores</HeadItem>
            </Head>
            <Body>
              {results.map((item: any, index: any) => (
                <BodyRow key={index} onClick={() => onClick(mapRowModalData(item))}>
                  <BodyItem flex={3}>{ item.date }</BodyItem>
                  <BodyItemForceWidth flex={9} title={item.title}>
                    <span>{ item.title }</span>
                  </BodyItemForceWidth>
                  <BodyItem flex={6}>{ item.author }</BodyItem>
                </BodyRow>
              ))}
            </Body>
          </>
        ) : (
          <NoResults>
            Sem resultados recentes
          </NoResults>
        )}
      </Table>
    </Content>
  );
}

const Content = styled.div`
  width: calc(54% - 12px);
  padding: 32px 0 0;
  position: relative;
  border: ${({ theme }) => `1px solid ${theme.colors.blue.dark}`};
  border-radius: 16px;
  padding: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: calc(100% - 54px);
    margin: auto;
    padding: 32px 0;
    border: none;
    border-radius: 0;
    border-top: ${({ theme }) => `2px solid ${theme.colors.blue.dark}`};
  }
`;

const Title = styled.span`
  display: inline-block;
  color: ${({ theme }) => theme.colors.blue.dark };
  text-transform: uppercase;
  font-size: 17px;
  margin-bottom: 16px;
  position: absolute;
  top: 0;
  left: 32px;
  transform: translateY(-50%);
  background-color: #fff;
  padding: 0 16px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    position: static;
    padding: 0;
    font-size: 20px;
    transform: none;
  }
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

const Head = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

const HeadItem = styled.span<ItemProps>`
  display: block;
  flex: ${({ flex }) => flex };
  font-size: 18px;
  color: ${({ theme }) => theme.colors.black.medium };
  font-style: italic;
`;

const Body = styled.ul`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  list-style-type: none;
`;

const BodyRow = styled.li`
  display: flex;
  border-bottom: ${({ theme }) => `1px dashed ${theme.colors.gray.darker}`};
  padding: 12px 0;
  cursor: pointer;

  &:last-child {
    border: none;
    padding-bottom: 0;
  }
`;

const BodyItem = styled.span<ItemProps>`
  display: block;
  flex: ${({ flex }) => flex };
  font-size: 15px;
  font-style: italic;
  color: ${({ theme }) => theme.colors.gray.darker };

  > span {
    display: inline-block;
    color: ${({ theme }) => theme.colors.black.medium };
    padding-right: 36px;
  }
`;

const BodyItemForceWidth = styled.span<ItemProps>`
  max-width: 300px;

  display: block;
  flex: ${({ flex }) => flex };
  font-size: 15px;
  font-style: italic;
  color: ${({ theme }) => theme.colors.gray.darker };

  > span {
    
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2; 
    -webkit-box-orient: vertical;

    color: ${({ theme }) => theme.colors.black.medium };
    padding-right: 36px;
  }
`;

const NoResults = styled.span`
  display: block;
  text-align: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.gray.darker };
`;
